img(v-if='imageNotFound' :class='{"-contain": contain}' :src='`${staticFilesUri}/${fallbackImageName}`' data-test='fallback-image')
img(v-else :src='url' @error='onNotFoundImage' data-test='image')
